import MTooltip from './Tooltip.vue';

export default MTooltip;
